@if (showGlobalSpinner) {
  <div id="globalSpinnerContainer">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
<div breadcrumbs [option]='breadcrumbOptions'></div>

<div class="heading">
  <h2 class="h2-title"> Image Library</h2>
</div>

<div class="panel">
  <section class="library-page">
    <section class="library-panel glass-panel">
      <div class="library-filters">
        <label>
          Search
          <input type="search" placeholder="Search by name"
            (input)="updateSearch($any($event.target).value)" />
          </label>
          <label>
            Tag
            <select (change)="updateTagFilter($any($event.target).value)">
              <option value="all">All</option>
              @for (tag of tagsCatalog; track tag) {
                <option [value]="tag.id">
                  {{ tag.tagKey }}
                </option>
              }
            </select>
          </label>
          <label>
            Sort by
            <select (change)="updateSort($any($event.target).value)">
              <option value="uploadDesc">Newest uploads</option>
              <option value="uploadAsc">Oldest uploads</option>
              <option value="nameAsc">Name (A → Z)</option>
              <option value="nameDesc">Name (Z → A)</option>
              <option value="tagAsc">Tag (A → Z)</option>
              <option value="tagDesc">Tag (Z → A)</option>
            </select>
          </label>
          <!-- FIXED ALIGNMENT COLUMN -->
          <div class="toggle-column">
            <div class=" default-gap toggle-block">
              <span>Defaults only</span>
              <label class="switch">
                <input type="checkbox" [checked]="filters.showDefaultsOnly"
                  (change)="toggleDefaultsOnly($any($event.target).checked)" />
                  <span class="switch__slider"></span>
                </label>
              </div>
              <small>{{ defaultCount }} / {{ tagsCatalog.length }} Tags</small>
            </div>
            <!-- Upload Button -->
            <button type="button" class="btn btn-primary filter-toggle__cta" (click)="openModal()">
              Upload image
            </button>
          </div>
          @if (filters.showDefaultsOnly && missingDefaultTags.length) {
            <div class="toggle-note">
              Defaults missing for <strong>{{ missingDefaultTags.join(', ') }}</strong>. Upload or assign defaults so
              every tag has coverage.
            </div>
          }

          @if (isLoadingLibrary) {
            <div class="alert alert--info">
              Loading...
            </div>
          }
          @if (loadError) {
            <div class="alert alert--error">
              {{ loadError }}
            </div>
          }

          @if (libraryStatus; as feedback) {
            <div class="alert" [ngClass]="'alert--' + feedback.type">
              {{ feedback.message }}
            </div>
          }
          <div class="library-scroll-container">
            @if (filteredImages.length) {
              <div class="library-table">
                <div class="library-row library-row--head">
                  <span>Name</span>
                  <span>Tag</span>
                  <!-- <span>File</span> -->
                  <!-- <span>Keywords</span> -->
                  <span>Uploaded</span>
                  <span>Actions</span>
                </div>
                @for (asset of filteredImages; track trackByImage($index, asset)) {
                  <div class="library-row">
                    <div>
                      <strong>{{ asset.name }}</strong>
                      @if (asset.isDefault) {
                        <span class="badge badge--default">Default</span>
                      }
                    </div>
                    <span><span class="tag-chip">{{ asset.tagLabel }}</span></span>
                    <!-- <span>
                    {{ asset.fileName }}
                    <small>{{ asset.sizeInKb }} KB</small>
                  </span> -->
                  <!-- <span class="keyword-list" *ngIf="asset.keywords.length; else noKeywords">
                  <span *ngFor="let keyword of asset.keywords" class="keyword">{{ keyword }}</span>
                </span>
                <ng-template #noKeywords>—</ng-template> -->
                <span>
                  {{ asset.uploadedAt | date: 'mediumDate' }}<br />
                  <!-- <small>{{ asset.uploadedBy }}</small> -->
                </span>
                <div class="actions">
                  <button type="button" class="btn btn-outline btn-small" (click)="setAsDefault(asset)"
                    [disabled]="asset.isDefault">
                    Set default
                  </button>
                  <button type="button" class="btn btn-secondary btn-small"
                  (click)="openPreview(asset)">Preview</button>
                  <button type="button" class="btn btn-danger btn-small"
                  (click)="deleteImage(asset)">Delete</button>
                </div>
              </div>
            }
          </div>
        } @else {
          @if (!showGlobalSpinner) {
            <div class="empty-state">
              <h3>No images match the current filters</h3>
              <p>Try clearing the search or uploading a new default for this category.</p>
            </div>
          }
        }
      </div>

    </section>
    @if (isModalOpen) {
      <div class="modal">
        <div class="modal__backdrop"></div>
        <div class="modal__panel" role="dialog" aria-modal="true" aria-labelledby="uploadDialogTitle"
          (click)="$event.stopPropagation()">
          <header class="modal__header">
            <h2 id="uploadDialogTitle">Upload to the shared library</h2>
            <button type="button" class="modal__close" aria-label="Close dialog" (click)="closeModal()">
              ✕
            </button>
          </header>
          <!-- Requirements -->
          <div class="modal__info">
            <p><strong>Requirements:</strong></p>
            <ul>
              <li>Max file size: <strong>10 MB</strong></li>
              <li>Allowed formats: <strong>{{ constraints.acceptedTypes }}</strong></li>
              <li>Required dimensions: <strong>1125 × 600 px</strong> (15:8)</li>
            </ul>
            <div class="hint">
              Tip: Keep the primary subject centered, avoid placing critical content near edges.
            </div>
          </div>
          <form [formGroup]="imageForm" (ngSubmit)="submitImage()" class="modal__form">
            <!-- Image name -->
            <label class="form-field">
              <span class="label">Image name</span>
              <input type="text" placeholder="e.g. Lakeside Sunset" formControlName="imageName" />
            </label>
            @if (imageForm.get('imageName')?.invalid && imageForm.get('imageName')?.touched) {
              <div class="field-error"
                >
                Provide a descriptive image name (max 50 characters).
              </div>
            }
            @if (imageNameExists) {
              <div class="field-error">
                Image name already exists. Please choose a different name.
              </div>
            }
            <!-- Tag -->
            <label class="form-field">
              <span class="label">Tag</span>
              <select formControlName="tagId">
                @for (tag of tagsCatalog; track tag) {
                  <option [ngValue]="tag.id">
                    {{ tag.tagKey }}
                  </option>
                }
              </select>
            </label>
            <!-- File -->
            <label class="form-field file-field">
              <span class="label">Upload image</span>
              <input type="file" [attr.accept]="constraints.acceptedTypes"
                (change)="onFileSelected($event)" />
              </label>
              <!-- File selected summary -->
              @if (selectedFileSummary; as s) {
                <div class="file-summary">
                  <!-- <div><strong>Selected:</strong> {{ s.name }}</div> -->
                  <div><strong>Size:</strong> {{ s.sizeKb }} KB</div>
                  <div>
                    <strong>Dimensions:</strong> {{ s.width }} × {{ s.height }} px
                    <span class="pill" [ngClass]="s.isValid ? 'pill--ok' : 'pill--bad'">
                      {{ s.isValid ? 'Valid' : 'Invalid' }}
                    </span>
                  </div>
                  <!-- <div class="field-error" *ngIf="s.message">
                  {{ s.message }}
                </div> -->
              </div>
            }
            <!-- File validation errors (from formControl) -->
            @if (imageForm.get('file')?.touched && imageForm.get('file')?.errors; as e) {
              <div class="field-error"
                >
                @if (e['required']) {
                  Please attach an image.
                }
                @if (e['invalidType']) {
                  Only PNG or JPG images are allowed.
                }
                @if (e['tooLarge']) {
                  File must be 10 MB or less.
                }
                @if (e['invalidDimensions']) {
                  Image must be exactly 1125 × 600 px (15:8).
                }
                @if (e['unreadable']) {
                  Could not read image dimensions. Try a different image.
                }
              </div>
            }
            <!-- Default -->
            <label class="checkbox-field">
              <input type="checkbox" formControlName="isDefault" />
              <span>Set as default image for the selected tag</span>
            </label>
            <!-- Status message -->
            @if (modalStatus; as modalFeedback) {
              <div class="alert" [ngClass]="'alert--' + modalFeedback.type">
                {{ modalFeedback.message }}
              </div>
            }
            <div class="modal__actions">
              <button type="button" class="btn btn-outline" (click)="closeModal()">Cancel</button>
              <button type="submit" class="btn btn-primary" [disabled]="imageForm.invalid">
                Upload & sync
              </button>
            </div>
          </form>
        </div>
      </div>
    }
    @if (isPreviewOpen && previewedAsset; as preview) {
      <div class="preview-overlay" (click)="closePreview()">
        <div class="preview-dialog" (click)="$event.stopPropagation()">
          <button class="preview-dialog__close" type="button" aria-label="Close preview"
          (click)="closePreview()">✕</button>
          <div class="preview-dialog__content">
            <!-- LEFT: IMAGE -->
            <div class="preview-dialog__image-wrapper">
              <img [src]="preview.contentUrl || 'https://placehold.co/1600x900?text=No+Preview+Available'"
                [alt]="preview.name" />
              </div>
              <!-- RIGHT: METADATA PANEL -->
              <div class="preview-dialog__meta">
                <h2 class="preview-title">{{ preview.name }}</h2>
                <dl class="meta-list">
                  <div class="meta-row">
                    <dt>Name</dt>
                    <dd>{{ preview.name }}</dd>
                  </div>
                  <div class="meta-row">
                    <dt>Tag</dt>
                    <dd class="tag-chip">{{ preview.tagLabel }}</dd>
                  </div>
                  <div class="meta-row">
                    <dt>Default</dt>
                    <dd class="tag-chip" [class.default]="preview.isDefault">
                      {{ preview.isDefault ? 'Yes' : 'No' }}
                    </dd>
                  </div>
                  <div class="meta-row">
                    <dt>Uploaded</dt>
                    <dd>{{ preview.uploadedAt | date: 'medium' }}</dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      }
    </section>
  </div>